import { FaHeart } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const FloatingDonateButton = () => {
  const navigate = useNavigate();

  return (
    <button
      onClick={() => navigate("/donate")}
      className="fixed bottom-6 right-6 z-50 bg-green-700 hover:bg-green-800 text-white px-4 py-3 rounded-full shadow-lg flex items-center gap-2 transition"
    >
      <FaHeart className="text-white" />
      <span className="font-medium">Donate Now</span>
    </button>
  );
};

export default FloatingDonateButton;
